import { useState } from "react";
import { CustomAbsolutePositionDropdownWrapper } from "./CustomDropdownWrapper";
import { Divider, Row, SizedBox } from "../CommonBaseComponents";
import { C3Text } from "../text/CustomText";
import CustomIcon from "../image/CustomIcon";
import SecondaryButton from "../button/SecondaryButton";
import Translate from "../../translate/Translate";
import PrimaryButton from "../button/PrimaryButton";
import { Theme } from "../../Theme";

export default function MultiCheckedDropdownMenu({
    initValues,
    setValues,
    values,
    onClose,
    openedLeftSide,
    onEmptySelect,
}) {
    const [currentValues, setCurrentValues] = useState(initValues);

    const applyValue = () => {
        setValues(currentValues);
        onClose();
    };

    const handleValueClick = (clickedValue) => {
        const firstValue = values && values.length > 0 ? values[0].value : null;

        if (!firstValue) return;

        setCurrentValues((prevValues) => {
            let newValues;

            if (clickedValue === firstValue) {
                newValues = [firstValue];
            } else {
                if (prevValues.includes(clickedValue)) {
                    newValues = prevValues.filter((item) => item !== clickedValue);
                } else {
                    newValues = [...prevValues, clickedValue];
                }
                newValues = newValues.filter((item) => item !== firstValue);
            }
            if (newValues.length === 0) {
                // onEmptySelect가 있으면 해제를 막고 알럿을 띄움(최소 1개 유지), 없으면 첫 옵션으로 리셋
                if (onEmptySelect) {
                    onEmptySelect();
                    return prevValues;
                }
                return [firstValue];
            }
            return newValues;
        });
    };

    return (
        <CustomAbsolutePositionDropdownWrapper openedLeftSide={openedLeftSide} width={"232px"}>
            <SizedBox height={"12px"} />
            {values.map((v) => (
                <SizedBox width={"100%"} height={"auto"} hoverBackgroundColor={Theme.color.neutral100}>
                    <Row
                        key={v.value}
                        justifyContent={"space-between"}
                        padding={"10px 20px"}
                        cursor={"pointer"}
                        onClick={() => handleValueClick(v.value)}
                        width={"100%"}
                    >
                        <C3Text fontColor={Theme.color.zinc850}>{v.label}</C3Text>

                        {currentValues.includes(v.value) && <CustomIcon iconName={"checked_active"} size={"15.5px"} />}
                    </Row>
                </SizedBox>
            ))}
            <Divider marginTop={"10px"} />
            <Row justifyContent={"flex-end"} padding={"12px"}>
                <SecondaryButton text={Translate("common.cancel")} onClick={onClose} />
                <SizedBox width={"7px"} />
                <PrimaryButton text={Translate("common.apply")} onClick={applyValue} />
            </Row>
        </CustomAbsolutePositionDropdownWrapper>
    );
}
